// Keep regular Elite Core login separate from an active Talent Portal session.
// Redirect only when the existing Talent session has been verified by App.
export function resolveGeneralLoginView({ token, isLoading, member } = {}) {
  if (!token) return "login";
  if (isLoading) return "checking";
  return member ? "talent" : "login";
}
